import cn from "classnames";
import type * as React from "react";
import styles from "./CustomDialogContent.module.less";
interface CustomDialogContentProps {
    className?: string;
    children?: React.ReactNode;
}
const CustomExtraContent: React.FC<CustomDialogContentProps> = ({ className, children }) => {
    return <div className={cn(styles.padded, className)}>{children}</div>;
};
CustomExtraContent.displayName = "CustomExtraContent"
const CustomDialogContent: React.FC<CustomDialogContentProps> = ({ className, children }) => {
    return <div className={cn(styles.content, styles.block, styles.padded, className)}>{children}</div>;
};
CustomDialogContent.displayName = "CustomDialogContent"
const CustomFlexDialogContent: React.FC<CustomDialogContentProps> = ({ className, children }) => {
    return <div className={cn(styles.content, styles.flex, className)}>{children}</div>;
};
CustomFlexDialogContent.displayName = "CustomFlexDialogContent"
export default CustomDialogContent;
export { CustomDialogContent, CustomFlexDialogContent, CustomExtraContent };
